




(function() {
  let attribution_string = '';

  const outboundLinks = document.getElementsByClassName('outbound-link')

  outboundLinks.forEach(link => {
    link.addEventListener('click', event => {
        event.preventDefault();
        const url = attribution_string ? event.target.href + '?' + attribution_string : event.target.href;
        window.location.assign(url)
    });
  });

  // parse query string for UTM values
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url);
  const paraobject = {}
  url.searchParams.forEach(function (val, key) {
    if(key.startsWith("utm_")) {
      attribution_string += key + '=' + val + '&';
    }
  });

})();

